import { jwtDecode } from "jwt-decode";
import { JwtPayloadTransformer, TokenResponse } from "../types";
export const decodeToken = (token: string): TokenResponse => {
  try {
    const decoded = jwtDecode<JwtPayloadTransformer>(token);
    const role =
      decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ||
      null;
    const sub = decoded.sub || null;
    const exp = decoded.exp ? decoded.exp * 1000 : null;
    const now = Date.now();
    const expired = exp !== null && now >= exp;
    return { role, expired, sub } as TokenResponse;
  } catch (e) {
    return { role: null, expired: true, sub: null } as TokenResponse;
  }
};
